import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";


export const v3_submitNewBuildingSiteQueryReportIndex = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-site-query-report-index/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitNewBuildingDrawingList = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-drawing-list/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_NewBuildingSiteQueryReportIndexForm = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-site-query-report-index/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_NewBuildingDrawingListForm = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-drawing-list/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_fetchNewBuildingSiteQueryReportIndexFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-site-query-report-index/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fetchNewBuildingDrawingListFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-drawing-list/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v3_submitNewBuildinSiteQuery = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-site-query/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_NewBuildingSiteQueryForm = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-site-query/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fetchNewBuildingSiteQueryFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-site-query/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitNewBuildinPotentialVariationOrderForm = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-potential-variation-order-form/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v3_submitNewBuildinOwnerNCRForm = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-owner-ncr/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v3_NewBuildingPotentialVariationOrderForm = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-potential-variation-order-form/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fetchNewBuildingotentialVariationOrderFormFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-potential-variation-order-form/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v3_submitNewBuildingCustomerPropertyInventory = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/customer-property-inventory-form/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fetchNewBuildingCustomerPropertyInventory = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/customer-property-inventory-form/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_NewBuildingCustomerPropertyInventory = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/customer-property-inventory-form/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitNewBuildingSiteAuditIndex = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-site-audit-index/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fetchNewBuildingSiteAuditIndex = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/new-building-site-audit-index/fields`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitPotentialVariationOrderIndexRegisterForm = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/potential-variable-order-index-register/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fetchPotentialVariationOrderIndexRegisterForm = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/potential-variable-order-index-register/fields`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitShipyardEvaluationPerformaceForm = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/shipyard-evaluation-performance/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_ShipyardEvaluationPerformaceForm = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/shipyard-evaluation-performance/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}





export const v3_fetchShipyardEvaluationPerformaceFormFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/shipyard-evaluation-performance/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_submitFatReportForm = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/fat-report/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}





export const v3_FatReportForm = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/fat-report/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetchFatReportFormFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/fat-report/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_submitMonthlyReportForm = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/monthly-report/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetchMonthlyReportFormFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/montly-report/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_MonthlyReportForm = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/monthly-report/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_submit_bi_weeklyReportForm = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/bi-weekly-report/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetch_bi_weeklyReportFormFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/bi-weekly-report/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_BiWeeklyReportForm = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management/bi-weekly-report/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
// Soft delete of a submitted form. One endpoint for all 10 Site Management forms;
// the API resolves formCode to its submission and log tables.
export const v3_delete_site_management_form = async (formCode, formId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/site-management-form/${encodeURIComponent(formCode)}/${formId}`;
    return customAxios.delete(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
